import mutationObserver from './utils/mutation-observer';

mutationObserver();
